import { toast } from "react-toastify";
import './notify.css';

/**
 *
 * @param {String} [message]
 * @param {String | 'success' | 'error' | 'warning' | 'info'} [type]
 */
export function notify(message = "", type = "success") {
  if(type=="error" || type=="warning" || type=="info"){
    alert(message);
    return;
  }else{
    return toast[type](message, {
      position: "top-right",
      autoClose: 1000,
      hideProgressBar: true,
    });
  }
}
